export default __webpack_public_path__ + "static/media/speakers__namrata-bandekar.dabdc201.jpg";